import React from 'react';
import DepartmentOverviewTopRow from '../portal/DepartmentOverviewTopRow';
import DepartmentWhatsNewCard from '../portal/DepartmentWhatsNewCard';
import DepartmentImplementationCard from '../portal/DepartmentImplementationCard';

const OPERATIONS_FALLBACK_SCHEDULE_URL =
  'https://calendly.com/daryl-yxbw/operations-strategy-call?hide_gdpr_banner=1';

const OperationsAllTab = () => {
  return (
    <div>
      {/* Community · Roadmap (with current task) · Goals */}
      <DepartmentOverviewTopRow category="operations" />

      {/* What's New (left) · Implementation Hours (right) */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <DepartmentWhatsNewCard department="operations" />
        <DepartmentImplementationCard
          department="operations"
          fallbackScheduleUrl={OPERATIONS_FALLBACK_SCHEDULE_URL}
        />
      </div>
    </div>
  );
};

export default OperationsAllTab;
